import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Card,
  Button,
  Icon,
} from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import { Breadcrumb, BackdropCircular} from 'components';
import { getStoreConfigsSummaryApi } from 'api';
import logo from 'components/Logo/logo-dermpro.svg';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';


const customTheme = createTheme({
  overrides: {
    MUIDataTableHeadCell: {
      data: {
        fontWeight: 'bold',
      }
    }
  }
});

const ConfigurationsSummary = () => {
  const dispatch = useDispatch();
  const {
    storeConfigsSummary,
    storeConfigsSummaryUpdatedAt,
    loadingStoreConfigsSummary
  } = useSelector((state) => state.store_configs);
  const { stores = [] } = useSelector((state) => state.user.profile);

  const date = new Date(storeConfigsSummaryUpdatedAt);

  useEffect(() => {
    if (storeConfigsSummary.length === 0) {
      getStoreConfigsSummaryApi({dispatch, refresh: false});
    }
  }, []);

  const refreshConfigsData = (refresh) => getStoreConfigsSummaryApi({dispatch, refresh});

  const columns = [
    {
      name: 'group',
      label: 'Configurations Group',
      options: {
        filterType: 'dropdown'
      }
    },
    {
      name: 'name',
      label: 'Name'
    },
    {
      name: 'value',
      label: 'Value',
      options: {
        customBodyRenderLite: (dataIndex) => {
          const config = storeConfigsSummary[dataIndex];
          let imgUrl = config.value;

          if (config.name.includes('Invoice Logo')) {
            imgUrl = `${stores[0]?.storeUrl}/media/sales/store/logo/${config.value}`;
          } else if (config.name.includes('Gift Card Logo')) {
            imgUrl = `${stores[0]?.storeUrl}/media/dermpro/giftcard/${config.value}`;
          }

          return (
            <>
              {config.name.includes('Logo') || config.name.includes('Favicon') ?
                <img onError={(event) => event.target.src = logo} src={imgUrl || logo} alt={config.name} className="max-w-300" />
                :
                config.value
              }
            </>
          );
        }
      }
    },
    {
      name: 'defaultValue',
      label: 'Default Value'
    }
  ];

  return (
    <div className="flex-grow flex-column relative h-full scroll-y">
      <div>
        <Breadcrumb
          routeSegments={[
            { name: 'Settings', path: '/settings#go_live_requirements' },
            { name: 'Store Configurations', path: '/settings#store_configurations' },
            { name: 'Summary' }
          ]}
        />
      </div>
      <div className="m-10">
        <Card className="p-8" elevation={25}>
          <div className="px-4 py-8 flex justify-between items-center">
            <div>
              <span>Last configurations update:</span>
              <span className="px-2 font-bold">{date.toLocaleDateString()} {date.toLocaleTimeString()}</span>
              <span>to get last data click Refresh button</span>
            </div>
            <Button
              color="primary"
              variant="contained"
              onClick={() => refreshConfigsData(true)}
            >
              <Icon className="mr-2">refresh</Icon>
              Refresh
            </Button>
          </div>
          <MuiThemeProvider theme={customTheme}>
            <MUIDataTable
              title={''}
              data={storeConfigsSummary}
              columns={columns}
              options={{
                filterType: 'textField',
                filter: true,
                selectableRows: false,
                download: true,
                print: false,
                search: true,
                pagination: true,
                viewColumns: true,
                rowsPerPage: 50,
                rowsPerPageOptions: [50, 100],
                setCellHeaderProps: () => ({className: 'font-bold text-muted'})
              }}
            />
          </MuiThemeProvider>
        </Card>
        <BackdropCircular loading={loadingStoreConfigsSummary} />
      </div>
    </div>
  );
};

export default ConfigurationsSummary;
